import { configRefs } from '@utils/constants';

function parseChildren(root, parsers, depth, options) {
  return Array.from(root.childNodes).map(
    (child, index) => parseNode(
      child,
      parsers,
      {
        parentNode: root,
        depth,
        index
      },
      options
    )
  ).filter(Boolean);
}
function parseChildrenWithoutText(root, parsers, depth, options) {
  return Array.from(root.childNodes).map(
    (child, index) => parseNode(
      child,
      parsers,
      {
        parentNode: root,
        depth,
        index
      },
      options
    )
  ).filter((it) => it && it.nodeType !== "text");
}
function parseNode(node, parsers, context, options) {
  if (isElementNode(node)) {
    return parseElement(node, parsers, context, options);
  }
  if (isTextNode(node)) {
    return parseText(node);
  }
  return null;
}
function parseElement(node, parsers, context, options) {
  const tagName = node.tagName.toLowerCase();
  const parser = (() => {
    const match = Object.keys(parsers).find(
      (parserSelector) => node.matches(parserSelector)
    );
    if (!match || !parsers[match]) {
      return parsers[tagName];
    }
    return parsers[match];
  })();
  if (!parser) {
    const { warnOnUnknownNode = true } = options ?? {};
    if (warnOnUnknownNode && configRefs.env.node.dangerouslyAssertSyncValue() !== "production") {
      console.trace(
        "xml2ast(): encountered unsupported element of type '%s' - parsers: %o",
        tagName,
        parsers,
        context.parentNode
      );
    }
    return null;
  }
  return parser(node, {
    ...context,
    extra: options == null ? void 0 : options.context
  });
}
function parseText(node) {
  if (node.nodeValue === null) {
    return null;
  }
  return {
    nodeType: "text",
    value: node.nodeValue
  };
}
function isElementNode(node) {
  return node.nodeType === node.ELEMENT_NODE;
}
function isTextNode(node) {
  return node.nodeType === node.TEXT_NODE;
}

export { isElementNode, isTextNode, parseChildren, parseChildrenWithoutText };
//# sourceMappingURL=core.parse-children.js.map
